import { observer } from 'mobx-react-lite'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { MESSAGING_METRICS_CONFIG } from 'entities/Analytics/lib/constants'
import type { MessagesChartDataStore } from 'pages/analytics/pages/messages/ui/Chart/store/messagesChartDataStore'
import {
  calculateYAxisWidth,
  getMaxValueFromMetrics,
} from 'pages/analytics/lib/calculateYAxisWidth'
import styles from 'pages/analytics/pages/messages/ui/Chart/ui/styles.module.scss'

interface MessagesBarChartProps {
  chartDataStore: MessagesChartDataStore
  hiddenMetrics?: Set<string>
}

export const MessagesBarChart = observer(
  ({ chartDataStore, hiddenMetrics = new Set() }: MessagesBarChartProps) => {
    const { rechartsData } = chartDataStore

    const maxValue = getMaxValueFromMetrics<Record<string, unknown>>(
      rechartsData as unknown as Record<string, unknown>[],
      MESSAGING_METRICS_CONFIG,
      hiddenMetrics
    )
    const yAxisWidth = calculateYAxisWidth(maxValue)

    return (
      <div className={styles.chartContainer}>
        <ResponsiveContainer width='100%' height={300}>
          <BarChart data={rechartsData} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
            <CartesianGrid vertical horizontal={false} strokeDasharray={'5'} />
            <XAxis dataKey='name' interval='preserveStartEnd' minTickGap={1} />
            <YAxis width={yAxisWidth} />
            <Tooltip cursor={false} />
            {Object.entries(MESSAGING_METRICS_CONFIG).map(([key, config]) => {
              if (hiddenMetrics.has(key)) return null

              return (
                <Bar key={key} dataKey={key} fill={config.color} name={config.name} radius={6} />
              )
            })}
          </BarChart>
        </ResponsiveContainer>
      </div>
    )
  }
)
